/* eslint-disable */
export default {
  en: '영어',
  ja: '일본어',
  fr: '프랑스어',
  de: '독일어',
  es: '스페인어',
  it: '이탈리아어',
  pt: '포르투갈어',
  zh: '중국어',
  nl: '네덜란드어',
  ko: '한국어',
  fi: '핀란드어',
} as const;

// @key: @#@"en"@#@ @source: @#@"English"@#@
// @key: @#@"ja"@#@ @source: @#@"Japanese"@#@
// @key: @#@"fr"@#@ @source: @#@"French"@#@
// @key: @#@"de"@#@ @source: @#@"Deutsch"@#@
// @key: @#@"es"@#@ @source: @#@"Spanish"@#@
// @key: @#@"it"@#@ @source: @#@"Italian"@#@
// @key: @#@"pt"@#@ @source: @#@"Portuguese"@#@
// @key: @#@"zh"@#@ @source: @#@"Chinese"@#@
// @key: @#@"nl"@#@ @source: @#@"Dutch"@#@
// @key: @#@"ko"@#@ @source: @#@"Korean"@#@
// @key: @#@"fi"@#@ @source: @#@"Suomi"@#@
